import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.mobile-app-support', {
        url: '/mobile-app-support',
        component: 'companyManageApplicationMobileAppSupport',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/mobile-app-support/mobile-app-support.state.js